import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vitrine-footer',
  templateUrl: './vitrine-footer.component.html',
  styleUrls: ['./vitrine-footer.component.css'],
  standalone: false
})
export class VitrineFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
